module.exports = __webpack_public_path__ + "img/origins.b506efd8.jpg";